import type { useLocation, useNavigate } from 'react-router-dom';

import {
  EDevice,
  LOCAL_STORAGE_KEYS,
  QUERY_PARAMS,
  URL_ROUTES
} from '@/constants';
import type {
  DeviceValues,
  TDeviceValue
} from '@/modules/perseo-billing/hooks/use-device-params/interfaces.ts';

const { ANDROID, IOS, WEB, KIOSCO } = EDevice;

export const isValidDevice = (device?: string | null): device is EDevice => {
  if (!device) return false;
  return (
    device === EDevice.WEB ||
    device === EDevice.ANDROID ||
    device === EDevice.IOS ||
    device === EDevice.KIOSCO
  );
};

export const getDeviceValues = (
  location: ReturnType<typeof useLocation>,
  cartSource: string
): DeviceValues => {
  const isOrderProcessing = location?.pathname?.includes(
    URL_ROUTES.BILLING_ORDER_PROCESSING_SUCCESS_PATH
  );
  return {
    fromStorage: localStorage.getItem(LOCAL_STORAGE_KEYS.DEVICE),
    fromQuery:
      new URLSearchParams(location.search).get(QUERY_PARAMS.DEVICE) ||
      EDevice.WEB,
    fromCart: !isOrderProcessing ? (cartSource ?? '') : null
  };
};

export const resolveDeviceValue = (deviceValues: DeviceValues) => {
  if (deviceValues?.fromQuery === EDevice.KIOSCO) {
    return deviceValues.fromQuery;
  }

  if (isValidDevice(deviceValues?.fromQuery)) {
    return deviceValues?.fromQuery;
  }

  return EDevice.WEB;
};

export const updateNavigation = (
  deviceValue: TDeviceValue,
  navigate: ReturnType<typeof useNavigate>
): void => {
  if (!deviceValue) return;

  const search = new URLSearchParams(window.location.search);

  if (deviceValue === WEB) {
    search.delete(QUERY_PARAMS.DEVICE);
  } else if (
    deviceValue === ANDROID ||
    deviceValue === IOS ||
    deviceValue === KIOSCO
  ) {
    search.set(QUERY_PARAMS.DEVICE, deviceValue);
  } else {
    return;
  }

  navigate(`?${search}`, { replace: true });
};
